<script lang="ts">
    import {_, time} from 'svelte-i18n'
    import type {Conversation, Session} from './types';
    import {Role} from './types';
    import {createEventDispatcher} from 'svelte';
    import IconButton from '@smui/icon-button';
    import Button from '@smui/button';
    import {Icon, Label} from '@smui/common';
    import SvelteTooltip from 'svelte-tooltip';
    import ConversationName from './ConversationName.svelte';
    import {isPaused, isStartable, isStarted, wasEnded} from './service/util';
    import ConversationActiveDuration from './ConversationActiveDuration.svelte';
    import ConversationWaitingDuration from './ConversationWaitingDuration.svelte';

    export let session: Session;
    export let conversation: Conversation;


    const dispatch = createEventDispatcher();

    function startConversation() {
        dispatch('conversation-start', conversation);
    }

    function closeConversation() {
        dispatch('conversation-close', conversation);
    }

    function endConversation() {
        dispatch('conversation-end', conversation);
    }

    function pauseConversation() {
        dispatch('conversation-pause', conversation);
    }

    function unpauseConversation() {
        dispatch('conversation-unpause', conversation);
    }
</script>

<div class="app-top-bar mdc-top-app-bar smui-top-app-bar--static">
    <div class="mdc-top-app-bar__row">
        {#if !session.roles.includes(Role.CLIENT)}
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <IconButton class="material-icons" on:click={closeConversation} title="Zpět">arrow_back</IconButton>
            </section>
        {/if}
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
            {#if !session.roles.includes(Role.CLIENT)}
				<span class="sm-hide">
					<ConversationName conversation={conversation} />
					&nbsp; | &nbsp;
                    {$_('chat.Waiting')}&nbsp;<ConversationWaitingDuration conversation={conversation} />
					&nbsp; | &nbsp;
				</span>
            {/if}
            <ConversationActiveDuration conversation={conversation} />
        </section>
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
			<span style="margin: 0 5px;">
				{#if session.roles.includes(Role.CLIENT)}
					<Button href="https://www.seznam.cz" variant="unelevated">
						<Label>
							{$_('chat.HideChat')}
                            <SvelteTooltip tip={$_('chat.HideChatTooltip')} bottom>
								<Icon class="material-icons" on:click={evt => evt.preventDefault()} style="margin-left: 0; margin-right: 0;">help_outline</Icon>
							</SvelteTooltip>
						</Label>
					</Button>
				{/if}
			</span>
            {#if isStartable(conversation, session)}
				<span style="margin: 0 5px;">
					<Button type="button" on:click={startConversation} variant="unelevated" color="secondary"><Label>{$_('chat.StartChat')}</Label></Button>
				</span>
            {/if}
            {#if isStarted(conversation)}
                {#if isPaused(conversation) && !session.roles.includes(Role.OPERATOR)}
					<span style="margin: 0 5px;">
						{$_('chat.Suspended')}
					</span>
                {/if}
                {#if session.roles.includes(Role.OPERATOR)}
                    {#if isPaused(conversation)}
						<span style="margin: 0 5px;">
							<Button type="button" on:click={unpauseConversation} variant="unelevated"><Label>{$_('chat.Continue')}</Label></Button>
						</span>
                    {:else}
						<span style="margin: 0 5px;">
							<Button type="button" on:click={pauseConversation} variant="unelevated"><Label>{$_('chat.SuspendChat')}</Label></Button>
						</span>
                    {/if}
                {/if}
            {/if}
            {#if wasEnded(conversation)}
				<span style="margin: 0 5px;">
					{$_('chat.Ended')} {$time(conversation.endDate, {format: 'short'})}
				</span>
            {:else if session.roles.includes(Role.OPERATOR)}
				<span style="margin: 0 5px;">
					<Button type="button" on:click={endConversation} variant="unelevated" color="secondary"><Label>{$_('chat.EndChat')}</Label></Button>
				</span>
            {/if}
        </section>
    </div>
</div>